module.exports = __webpack_public_path__ + "static/media/employee_in_out.3b86ac87.jpg";